import HomepageLink from 'components/HomepageLink/HomepageLink.component';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type CompactHomepageLinkProps = {
  logoLink: string;
};

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const CompactHomepageLink = ({ logoLink }: CompactHomepageLinkProps) => {
  return <HomepageLink href={logoLink} />;
};

export { CompactHomepageLink };
